<template>
  <section v-if="isActive" class="section">
    <div class="container">
      <LinePlot
        v-show="showGraph"
        :display="showGraph"
        :simulations="simulations"
        :statsType="statsType"
      ></LinePlot>
      <StatsTable
        v-show="showTable"
        :simulations="simulations"
        :statsType="statsType"
      ></StatsTable>
      <DisplayOptionsLevel
        @change-stats-type="changeStatsType"
        @change-display-type="changeDisplayType"
      ></DisplayOptionsLevel>
    </div>
  </section>
</template>

<script>
import LinePlot from "./LinePlot";
import DisplayOptionsLevel from "./DisplayOptionsLevel";
import StatsTable from "./StatsTable";
export default {
  name: "PMFPlot",
  components: { StatsTable, DisplayOptionsLevel, LinePlot },
  data() {
    return {
      statsType: "damage",
      displayType: "graph"
    };
  },
  computed: {
    simulations() {
      return this.$store.state.simulations;
    },
    isActive() {
      return this.simulations.length > 0;
    },
    showGraph() {
      return this.displayType === "graph";
    },
    showTable() {
      return this.displayType === "table";
    }
  },
  methods: {
    changeStatsType(statsType) {
      this.statsType = statsType;
    },
    changeDisplayType(displayType) {
      this.displayType = displayType;
    }
  }
};
</script>
